import Api from '../utils/Api';

const get = (caller) => {
    return Api.makeRequest(`/users/me/meditations`, 'GET', null, caller);
};

const create = (caller, data) => {
    return Api.makeRequest(`/meditations`, 'POST', data, caller, data);
};

const complete = (caller, id) => {
    return Api.makeRequest(`/users/me/meditations/${id}`, 'PUT', {
        "status": 'completed'
    }, caller, id);
};

const start = (caller, id) => {
    return Api.makeRequest(`/users/me/meditations`, 'POST', {
        "id": id
    }, caller, id);
};

const saveProgress = (caller, data) => {
    return Api.makeRequest(`/users/me/meditations/${data.id}`, 'PUT', {
        "progress": data.progress,
        "status": "progress"
    }, caller, data);
};

const rate = (caller, data) => {
    return Api.makeRequest(`/users/me/meditations/${data.id}`, 'PUT', {
        "rating": data.rating
    }, caller, data);
};

export { get, create, complete, start, saveProgress, rate };


// WEBPACK FOOTER //
// ./src/models/Meditation.js